import * as React from 'react';
import loadMore from 'owa-mail-reading-pane-store/lib/actions/loadMore';
import strings from 'owa-strings/owa-mail-strings';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { Spinner } from 'office-ui-fabric-react/lib/Spinner';
import { observer } from 'mobx-react';
var styles = require('./MailListItemExpansionLoadMoreButton.scss');
var classNames = require('classnames/bind');
export default observer(function MailListItemExpansionLoadMoreButton(props) {
    var loadMoreStyles = {
        root: classNames(styles.loadMoreButtonRoot, props.isSingleLineView ? styles.singleLineLeftPadding : styles.threeColumnLeftPadding),
        textContainer: styles.loadMoreText,
        flexContainer: styles.loadMoreButtonFlexContainerStyles,
    };
    var iconStyles = {
        root: styles.loadMoreDoubleChevronIconRoot,
    };
    return props.isLoadMoreInProgress ? (React.createElement("div", { className: classNames(styles.loadCommon, props.isSingleLineView
            ? styles.singleLineLeftPadding
            : styles.threeColumnLeftPadding) },
        React.createElement("div", { className: styles.loadingFlexContainer },
            React.createElement(Spinner, null),
            React.createElement("span", { className: styles.loadingText }, strings.loading)))) : (React.createElement(DefaultButton, { onClick: function (evt) { return onLoadMore(evt, props.conversationId); }, styles: loadMoreStyles, text: strings.loadMore, iconProps: {
            iconName: props.isNewestOnBottom
                ? "DoubleChevronUp" /* DoubleChevronUp */
                : "DoubleChevronDown" /* DoubleChevronDown */,
            styles: iconStyles,
        } }));
});
var onLoadMore = function (event, conversationId) {
    event.stopPropagation();
    loadMore(conversationId);
};
//# sourceMappingURL=MailListItemExpansionLoadMoreButton.js.map